import {
  Box,
  Grid,
  Typography,
  Container,
} from "@mui/material";
import { useParams, Navigate } from "react-router-dom";
import { PROJECTS_MAP } from "../assets/contents";

const ProjectSection = ({ project }) => {

  return (
    <Box
      sx={{
        py: { xs: 2, sm: 4, md: 6 },
        px: { xs: 2.5, sm: 5, md: 7 },
        display: "flex",
        justifyContent: "center",
      }}
    >
      <Grid
        container
        spacing={{ xs: 4, sm: 5, md: 7 }}
        alignItems="center"
        justifyContent="space-between"
        sx={{
          maxWidth: "1200px",
          width: "100%",
          flexDirection: { xs: "column", sm: "column", md: "row" },
        }}
      >
        {/* LEFT TEXT */}
        <Grid item size={12}>
          <Box sx={{ textAlign: { xs: "center", md: "left" } }}>
            <Typography
              sx={{
                fontFamily: "'Playfair Display', serif",
                fontWeight: 600,
                color: "#b1976b",
                mb: 1,
                fontSize: {
                  xs: "1.7rem",
                  sm: "2rem",
                  md: "2.5rem",
                },
              }}
            >
              {project.head}
            </Typography>

            <Typography
              sx={{
                fontFamily: "'Poppins', sans-serif",
                fontWeight: 600,
                mb: 2,
                color: "#000",
                letterSpacing: 1,
                fontSize: { xs: "0.8rem", sm: "0.9rem", md: "1rem" },
              }}
            >
              {project.content}
            </Typography>
          </Box>
        </Grid>

        {project.imagesSet?.length > 0 && (
          <Grid
            item
            size={12}
            sx={{
              px: { xs: 1, md: 3, lg: 5 },
              display: "flex",
              justifyContent: { xs: "center", md: "flex-start" },
              flexWrap: "wrap",
              gap: 2,
            }}
          >
            {/* Horizontal IMAGEs */}
            {project.imagesSet.map((imge) => (
              <Box
                component="img"
                src={imge}
                alt={project.head}
                sx={{
                  maxWidth: { xs: "300px", sm: "400px", md: "550px" },
                }}
              />
            ))}
            {/* Vertical IMAGEs */}
            {project.imagesVSet.map((imge) => (
              <Box
                component="img"
                src={imge}
                alt={project.head}
                sx={{
                  maxWidth: { xs: "250px", sm: "350px", md: "500px" },
                }}
              />
            ))}
          </Grid>
        )}
      </Grid>
    </Box>
  );
};

const ExploreProjects = () => {
  const { id } = useParams();

  const projectsData = PROJECTS_MAP[id];

  // safety fallback
  if (!projectsData) {
    return <Navigate to="/projects" replace />;
  }

  const paBox = {
    display: "flex",
    flexDirection: { xs: "column", md: "row" },
    gap: 4,
    px: { xs: 2, md: 12 },
    py: { xs: 1, md: 2 },
    backgroundColor: "#fff",
    alignItems: { xs: "center", md: "flex-start" },
  };

  const chBox = {
    display: { xs: "block", md: "flex" },
    gap: 2,
    alignItems: "center",
  };

  const chParaBox = {
    display: { xs: "block", md: "flex" },
    gap: 2,
    alignItems: "start",
  };

  const headText = {
    fontWeight: 700,
    color: "#b2925a",
    fontFamily: "serif",
    flex: 1,
    textAlign: { xs: "center", md: "left" },
    fontSize: { xs: "1.4rem", sm: "1.8rem", md: "2rem" },
  };

  const contentText = {
    fontFamily: "'Poppins', sans-serif",
    fontWeight: 600,
    color: "#000",
    letterSpacing: 1,
    textAlign: { xs: "center", md: "left" },
    pt: 1,
  };

  const contentParaText = {
    color: "#333",
    fontWeight: 500,
    letterSpacing: 1,
    textAlign: "justify",
    pt: 1.5,
  };

  return (
    <Box sx={{ backgroundColor: "#fff", width: "100%" }}>
      <Container maxWidth="xl" disableGutters>
        <Box
          sx={{
            display: "flex",
            px: { xs: 2, md: 12 },
            py: { xs: 2, md: 5 },
            backgroundColor: "#fff",
            justifyContent: "center",
          }}
        >
          <Box>
            <Typography
              variant="h4"
              sx={{
                fontWeight: 700,
                color: "#b2925a",
                fontFamily: "serif",
                flex: 1,
                textAlign: { xs: "center", md: "left" },
              }}
            >
              {projectsData.title}
            </Typography>
            <Typography
              sx={{
                fontFamily: "'Poppins', sans-serif",
                fontWeight: 600,
                color: "#000",
                textAlign: { xs: "center", md: "left" },
                letterSpacing: 1,
                fontSize: { xs: "0.8rem", sm: "0.9rem", md: "1rem" },
              }}
            >
              {projectsData.location}
            </Typography>
          </Box>
        </Box>

        <Box sx={paBox}>
          <Box sx={chBox}>
            <Typography variant="h4" sx={headText}>
              Socpe:
            </Typography>
            <Typography sx={contentText}>{projectsData.scope}</Typography>
          </Box>
        </Box>

        {projectsData.objective !== "" && (
          <Box sx={paBox}>
            <Box sx={chBox}>
              <Typography variant="h4" sx={headText}>
                Objective:
              </Typography>
              <Typography sx={contentText}>{projectsData.objective}</Typography>
            </Box>
          </Box>
        )}

        <Box sx={paBox}>
          <Box sx={chParaBox}>
            <Typography variant="h4" sx={headText}>
              Execution:
            </Typography>
            <Typography variant="body1" sx={contentParaText}>
              {projectsData.execution}
            </Typography>
          </Box>
        </Box>

        <Box sx={paBox}>
          <Box sx={chParaBox}>
            <Typography variant="h4" sx={headText}>
              The Mandate:
            </Typography>
            <Typography variant="body1" sx={contentParaText}>
              {projectsData.mandate}
            </Typography>
          </Box>
        </Box>

        <Typography
          variant="h4"
          sx={{
            fontWeight: 700,
            color: "#b2925a",
            fontFamily: "serif",
            flex: 1,
            textAlign: "center",
            textDecoration: "underline",
            mt: 4,
          }}
        >
          {projectsData.helightTitle}
        </Typography>

        {projectsData?.highlights.map((proj, idx) => (
          <ProjectSection key={idx} project={proj} />
        ))}
      </Container>
    </Box>
  );
};

export default ExploreProjects;
